module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (27).cb5d13bc.jpg";